export default [
    { name: 'HTML' },
    { name: 'CSS/SASS' },
    { name: 'Javascript' },
    { name: 'React' },
    { name: 'Angular' },
    { name: 'Bootstrap' },
    { name: 'jQuery' },
];